import { Runtime } from '../Runtime';

export class RuntimeInfo {
  readonly parent: Runtime;

  constructor(parent) {
    this.parent = parent;
  }

  get runtime() {
    return this.parent;
  }



}
